export const REQUEST_DATACENTERS = 'REQUEST_DATACENTERS';
export type REQUEST_DATACENTERS = typeof REQUEST_DATACENTERS;

export const REQUEST_DATACENTERS_SUCCESS = 'REQUEST_DATACENTERS_SUCCESS';
export type REQUEST_DATACENTERS_SUCCESS = typeof REQUEST_DATACENTERS_SUCCESS;

export const REQUEST_DATACENTERS_FAILED = 'REQUEST_DATACENTERS_FAILED';
export type REQUEST_DATACENTERS_FAILED = typeof REQUEST_DATACENTERS_FAILED;

export const UPDATE_DATACENTER = 'UPDATE_DATACENTER';
export type UPDATE_DATACENTER = typeof UPDATE_DATACENTER;

export const UPDATE_DATACENTER_SUCCESS = 'UPDATE_DATACENTER_SUCCESS';
export type UPDATE_DATACENTER_SUCCESS = typeof UPDATE_DATACENTER_SUCCESS;

export const UPDATE_DATACENTER_FAILED = 'UPDATE_DATACENTER_FAILED';
export type UPDATE_DATACENTER_FAILED = typeof UPDATE_DATACENTER_FAILED;

export const ADD_REGION = 'ADD_REGION';
export type ADD_REGION = typeof ADD_REGION;

export const ADD_REGION_SUCCESS = 'ADD_REGION_SUCCESS';
export type ADD_REGION_SUCCESS = typeof ADD_REGION_SUCCESS;

export const ADD_REGION_FAILED = 'ADD_REGION_FAILED';
export type ADD_REGION_FAILED = typeof ADD_REGION_FAILED;

export const ADD_ZONE = 'ADD_ZONE';
export type ADD_ZONE = typeof ADD_ZONE;

export const ADD_ZONE_SUCCESS = 'ADD_ZONE_SUCCESS';
export type ADD_ZONE_SUCCESS = typeof ADD_ZONE_SUCCESS;

export const ADD_ZONE_FAILED = 'ADD_ZONE_FAILED';
export type ADD_ZONE_FAILED = typeof ADD_ZONE_FAILED;

export const UPDATE_VCENTER = 'UPDATE_VCENTER';
export type UPDATE_VCENTER = typeof UPDATE_VCENTER;

export const UPDATE_VCENTER_SUCCESS = 'UPDATE_VCENTER_SUCCESS';
export type UPDATE_VCENTER_SUCCESS = typeof UPDATE_VCENTER_SUCCESS;

export const UPDATE_VCENTER_FAILED = 'UPDATE_VCENTER_FAILED';
export type UPDATE_VCENTER_FAILED = typeof UPDATE_VCENTER_FAILED;

export const DELETE_DATACENTER = 'DELETE_DATACENTER';
export type DELETE_DATACENTER = typeof DELETE_DATACENTER;

export const DELETE_VCENTER = 'DELETE_VCENTER';
export type DELETE_VCENTER = typeof DELETE_VCENTER;
